(() => {
  const body = document.querySelector('body'),
        windowHeight = window.innerHeight,
        sectionContent = document.querySelector('.predictiveSearch__content'),
        sectionResults = document.querySelector('.predictiveSearch__results'),
        sectionWrapper = document.querySelector('.predictiveSearch__wrapper'),
        searchTogglers = document.querySelectorAll('.toggleSearch'),
        searchSection = document.querySelector('.predictiveSearch'),
        searchInput = document.querySelector('.predictiveSearch__form input'),
        searchButtons = document.querySelectorAll('.predictiveSearch__button'),
        searchSize = document.querySelector('.predictiveSearch').dataset.searchSize;

  document.documentElement.style.setProperty('--window-height', windowHeight + "px");

  function toggleSearch() {
    body.classList.toggle('overflow');
    searchSection.classList.toggle('predictiveSearch--active');
    if (searchSection.classList.contains('predictiveSearch--active')) {
      searchInput.focus();
    }
  }

  function search(value) {
    fetch(
      `/search/suggest?q=${value}&resources[limit]=${searchSize}&resources[limit_scope]=each&resources[type]=product,collection,article,page&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,variants.sku,body,tag&section_id=predictive-search`
    ).then(response => {
      if (response.ok) {
        return response.text();
      } else {
        throw new Error('Search error');
      }
    }).then((text) => {
      const searchData = new DOMParser().parseFromString(text, 'text/html'),
            searchResults = searchData.querySelector('.predictiveSearch__results').innerHTML,
            searchContentWrapper = searchData.querySelector('.predictiveSearch__resultsWrapper'),
            searchLinkParameter = searchData.querySelector('.predictiveSearch__resultsProductsHeader a'),
            searchContent = document.querySelector('.predictiveSearch__results');

      searchContent.innerHTML = searchResults;

      sectionWrapper?.classList.add('predictiveSearch__wrapper--border');
      sectionContent?.classList.add('predictiveSearch__content--hidden');

      if (searchContentWrapper) {
        searchButtons.forEach(button => {
          button.disabled = false;

          button.addEventListener('click', () => {
            window.location.href = `${searchLinkParameter.href}`;
          });
        });
      }
    }).catch(error => {
      console.error(error.message);
    });
  }

  const handleSearchInputKeyup = debounce((value) => {
    if (value.length !== 0) {
      search(value);
    }

    if (value.length === 0) {
      sectionContent.classList.remove('predictiveSearch__content--hidden');
      sectionResults.innerHTML = '';

      searchButtons.forEach(button => {
        button.disabled = true;
      });
    }
  }, 500);

  searchInput.addEventListener('keyup', (e) => {
    handleSearchInputKeyup(e.currentTarget.value);
  });

  searchTogglers.forEach(searchToggler => {
    searchToggler.addEventListener('click', toggleSearch);
  });
})();
